import { FieldType } from 'modules/domains';

export const isNumericField = (fieldType: FieldType) =>
  [FieldType.DATE, FieldType.INTEGER, FieldType.FLOAT].includes(fieldType);
